<template>
    

    <div class='card purshase-product-info mb-4'>
        
        <div  class='card-header product-name '>
            <!-- <div class='index' v-if="index > 0"> {{ index }} </div> -->
            <h5 class='name'> {{product.fullname.replace(/^[^\/]*?\//,'')}} </h5> 
            <!-- <ico class='delete' @click="removePurshaseProduct" icon='trash'></ico> -->
        </div>

        <div class='info card-body'>
            <team-list-new :team="team"></team-list-new>  
            <hr class='mt-2 mb-2 pb-2' />
            <member-list-new class='mt-5' :members="members"></member-list-new>
        </div>

        <button @click="save" class="btn btn-primary"> Salvar Informações </button>

    </div>

</template>

<script>
export default {
    data(){
        return {
            open:false
            }
    },
    props:{
        purshaseProduct:{
            type:Object
        },
        index:{
            type:Number,
            default:0
        }
    },

    computed:{
        product:function(){
            return (this.purshaseProduct.product || false);
        },
        members:function(){
            return this.purshaseProduct.members;
        },
        team:function(){
            return this.purshaseProduct.team;
        },
        needFill:function(){
            return this.purshaseProduct.teamDefinitions.needFillOnPurchase;
        },
    },

    methods:{
        save:async function(){
            await this.$store.dispatch('PurchaseStore/savePurchase',this.purshaseProduct.id)
            this.$router.back();
        }
    }
}
</script>

<style lang="stylus">

.product-name{
    position:relative;
    background var(--product-selector-bg-color);

    .index{
        position:absolute;
        width larg = 25px;
        height: larg
        border-radius:25px 0 0 25px;
        left:-(larg);
        top:2px;
        background:var(--product-selector-color)
        line-height: larg;
        color:white;
        font-weight:bolder;
        text-align:center;
        // opacity:0.6;
    }
    .name{
        color:white;
    }
    .delete{
        position:absolute;
        color:white;
        right:15px;
        top:15px;
        opacity:0.9;
        cursor:pointer;
    }    
}

</style>
